import axios from 'axios';
import config from '../config/config';

const api = axios.create({
  baseURL: config.apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token to all requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const getUsageStats = async (orgId: string) => {
  const response = await api.get(`${config.apiBaseUrl}/documents/usage?org_id=${orgId}`);
  return response.data;
};

export const getQuotaStatus = async () => {
  const response = await api.get(`${config.apiBaseUrl}/documents/quota-status`);
  return response.data;
};

export const getAdminStats = async (orgId?: string) => {
  const url = orgId ? `${config.apiBaseUrl}/data/stats?org_id=${orgId}` : `${config.apiBaseUrl}/data/stats`;
  const response = await api.get(url);
  return response.data;
};

export const getOrganizations = async () => {
  const response = await api.get(`${config.apiBaseUrl}/organizations`);
  return response.data;
};

export const archiveDocument = async (documentId: number) => {
  const response = await api.post(`${config.apiBaseUrl}/documents/${documentId}/archive`);
  return response.data;
};

export default api;
